import { RIGHTSHOLDER_SUB_ROUTES, ROYALTIES_ROUTE } from '@App/navigation/route'
import PermissionCheck from '@Components/Utility/PermissionCheck'
import { PERMISSIONS } from '@Const/permissions'
import Navigation from '@App/navigation'
import RightsholderRoyaltiesStatements from '@Scenes/RightsholderScene/RightsholderRoyaltiesStatements'
import RightsholderRoyaltiesAnnualStatements from '@Scenes/RightsholderScene/RightsholderRoyaltiesAnnualStatements'
import RightsholderRoyaltiesRateSheets from '@Scenes/RightsholderScene/RightsholderRoyaltiesRateSheets'
import RightsholderRoyalties from '@Scenes/RightsholderScene/RightsholderRoyalties'
import React from 'react'
import RoyaltiesLayout from '@Scenes/RightsholderScene/RoyaltiesLayout'

export const createRoyaltiesRoutes = () => [
    {
        path: RIGHTSHOLDER_SUB_ROUTES.royalties.root,
        element: (
            <PermissionCheck
                requiredPermissions={[
                    PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_contact_and_address,
                    PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_banking_and_tax,
                ]}
                orIsInternal
                reRouteLocation={Navigation.home.root()}
            >
                <RoyaltiesLayout />
            </PermissionCheck>
        ),
        children: [
            {
                index: true,
                element: <RightsholderRoyalties />,
            },
            {
                path: RIGHTSHOLDER_SUB_ROUTES.royalties.statements,
                element: <RightsholderRoyaltiesStatements />,
            },
        ],
    },
    {
        path: `${ROYALTIES_ROUTE}/${RIGHTSHOLDER_SUB_ROUTES.royalties.annualStatements}`,
        element: (
            <PermissionCheck
                requiredPermissions={[
                    PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_contact_and_address,
                    PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_banking_and_tax,
                ]}
                orIsInternal
                reRouteLocation={Navigation.home.root()}
            >
                <RightsholderRoyaltiesAnnualStatements />
            </PermissionCheck>
        ),
    },
    {
        path: `${ROYALTIES_ROUTE}/${RIGHTSHOLDER_SUB_ROUTES.royalties.rateSheets}`,
        element: (
            <PermissionCheck
                requiredPermissions={[
                    PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_contact_and_address,
                    PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_banking_and_tax,
                ]}
                orIsInternal
                reRouteLocation={Navigation.home.root()}
            >
                <RightsholderRoyaltiesRateSheets />
            </PermissionCheck>
        ),
    },
]
